/**
 * Helper to identify if the argument is a function
 * @param {object} obj
 * @returns bool
 */
function isFunction(obj) {
  return typeof obj === 'function';
}

/**
 * Function to notify that a function is deprecated or a method in a object
 * @param {Object|Function} obj
 * @param {Object} config
 * @returns Object|Function
 */

function _deprecate(obj, config) {
  const { method = null, message = 'This will be deprecated soon', logger = console } = config || {};

  if (obj == null) {
    throw new Error('[Deprecate]: The param obj is required');
  }

  if (isFunction(obj)) {
    logger.warn('[Deprecated]:', message);
    return obj;
  }

  if (!isFunction(obj[method])) {
    throw new Error('[Deprecate]: The object not have the method defined');
  }

  return new Proxy(obj, {
    get(_, property) {
      if (property === method) {
        logger.warn('[Deprecated]:', message);
      }
      return Reflect.get(...arguments);
    },
  });
}

export function deprecate(obj, config) {
  if (process.env.NODE_ENV === 'development') {
    return _deprecate(obj, config);
  }
  return obj;
}
